import { FC, ReactElement } from 'react'
import styled from 'styled-components'

const ExplanationModule: FC = (): ReactElement => {
  return (
    <Container>Les effets du Valproate sur la 2ème génération</Container>
  )
}
const Container = styled.div`
    background-color: #222233;
    display: flex;
    align-items: center;
    justify-content: center;
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  height: 100vh;
  color: white;
`

export default ExplanationModule